<form [formGroup]="penScoreFormGroup">
  <hr />

  <div class="spacing--margin-bottom">
    <h2>{{ 'fecal-scoring.detail.penscore.title' | translate }}</h2>
  </div>
  <div>
    {{ 'fecal-scoring.detail.penscore.subtitle' | translate }}
  </div>

  <div class="spacing--margin-top">
    <div class="spacing--margin-top flex--row flex--wrap">
      <div class="flex--column">
        <h3>{{ 'fecal-scoring.detail.penscore.fecalnormal' | translate }}</h3>
      </div>
    </div>
  </div>

  <div class="spacing--margin-top spacing--margin-bottom flex--wrap flex--row penscorediv">
    <div class="flex--column penscoreimgdiv">
      <img src="assets/images/FecalScoring/FecalNormal.jpg" class="penscoreimg" />
    </div>
    <div class="flex--column spacing--margin-left penvaluediv">
      <span class="text--small text--bold label"
        >{{ 'fecal-scoring.detail.penscore.value' | translate }}:
        {{ penScoreFormGroup.controls.penScoreNormal.value }}%
      </span>
      <div class="flex--column spacing--margin-right penslider">
        <mat-slider
          discrete
          showTickMarks
          min="0"
          max="100"
          step="5"
          data-test="create-fecal-scoring__fecal-scoring-penscorenormal"
        >
          <input matSliderThumb formControlName="penScoreNormal" />
        </mat-slider>
      </div>

      <div class="spacing--margin-top">
        <div class="spacing--margin-bottom">
          <div>
            {{ 'fecal-scoring.detail.penscore.fecaltotal' | translate }}
            <span
              class="text--bold"
              [ngClass]="totalScore !== 100 ? 'text-color--warn-500' : 'text-color--primary-500'"
              >{{ totalScore }}%</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>

  <hr />

  <div class="spacing--margin-top">
    <div class="spacing--margin-top flex--row flex--wrap">
      <div class="flex--column">
        <h3>{{ 'fecal-scoring.detail.penscore.fecalsoft' | translate }}</h3>
      </div>
    </div>
  </div>

  <div class="spacing--margin-top spacing--margin-bottom flex--row flex--wrap penscorediv">
    <div class="flex--column penscoreimgdiv">
      <img src="assets/images/FecalScoring/FecalSoft.jpg" class="penscoreimg" />
    </div>
    <div class="flex--column spacing--margin-left penvaluediv">
      <span class="text--small text--bold label"
        >{{ 'fecal-scoring.detail.penscore.value' | translate }}:
        {{ penScoreFormGroup.controls.penScoreSoft.value }}%
      </span>
      <div class="flex--column spacing--margin-right penslider">
        <mat-slider
          discrete
          showTickMarks
          min="0"
          max="100"
          step="5"
          data-test="create-fecal-scoring__fecal-scoring-penscoresoft"
        >
          <input matSliderThumb formControlName="penScoreSoft" />
        </mat-slider>
      </div>

      <div class="spacing--margin-top">
        <div class="spacing--margin-bottom">
          <div>
            {{ 'fecal-scoring.detail.penscore.fecaltotal' | translate }}
            <span
              class="text--bold"
              [ngClass]="totalScore !== 100 ? 'text-color--warn-500' : 'text-color--primary-500'"
              >{{ totalScore }}%</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>

  <hr />

  <div class="spacing--margin-top">
    <div class="spacing--margin-top flex--row flex--wrap">
      <div class="flex--column">
        <h3>{{ 'fecal-scoring.detail.penscore.fecalmild' | translate }}</h3>
      </div>
    </div>
  </div>

  <div class="spacing--margin-top spacing--margin-bottom flex--row flex--wrap penscorediv">
    <div class="flex--column penscoreimgdiv">
      <img src="assets/images/FecalScoring/FecalMild.jpg" class="penscoreimg" />
    </div>
    <div class="flex--column spacing--margin-left penvaluediv">
      <span class="text--small text--bold label"
        >{{ 'fecal-scoring.detail.penscore.value' | translate }}:
        {{ penScoreFormGroup.controls.penScoreMild.value }}%
      </span>
      <div class="flex--column spacing--margin-right penslider">
        <mat-slider
          discrete
          showTickMarks
          min="0"
          max="100"
          step="5"
          data-test="create-fecal-scoring__fecal-scoring-penscoremild"
        >
          <input matSliderThumb formControlName="penScoreMild" />
        </mat-slider>
      </div>

      <div class="spacing--margin-top">
        <div class="spacing--margin-bottom">
          <div>
            {{ 'fecal-scoring.detail.penscore.fecaltotal' | translate }}
            <span
              class="text--bold"
              [ngClass]="totalScore !== 100 ? 'text-color--warn-500' : 'text-color--primary-500'"
              >{{ totalScore }}%</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>

  <hr />

  <div class="spacing--margin-top">
    <div class="spacing--margin-top flex--row flex--wrap">
      <div class="flex--column">
        <h3>{{ 'fecal-scoring.detail.penscore.fecalmoderate' | translate }}</h3>
      </div>
    </div>
  </div>

  <div class="spacing--margin-top spacing--margin-bottom flex--row flex--wrap penscorediv">
    <div class="flex--column penscoreimgdiv">
      <img src="assets/images/FecalScoring/FecalModerate.jpg" class="penscoreimg" />
    </div>
    <div class="flex--column spacing--margin-left penvaluediv">
      <span class="text--small text--bold label"
        >{{ 'fecal-scoring.detail.penscore.value' | translate }}:
        {{ penScoreFormGroup.controls.penScoreModerate.value }}%
      </span>
      <div class="flex--column spacing--margin-right penslider">
        <mat-slider
          discrete
          showTickMarks
          min="0"
          max="100"
          step="5"
          data-test="create-fecal-scoring__fecal-scoring-penscoremoderate"
        >
          <input matSliderThumb formControlName="penScoreModerate" />
        </mat-slider>
      </div>

      <div class="spacing--margin-top">
        <div class="spacing--margin-bottom">
          <div>
            {{ 'fecal-scoring.detail.penscore.fecaltotal' | translate }}
            <span
              class="text--bold"
              [ngClass]="totalScore !== 100 ? 'text-color--warn-500' : 'text-color--primary-500'"
              >{{ totalScore }}%</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>

  <hr />

  <div class="spacing--margin-top">
    <div class="spacing--margin-top flex--row flex--wrap">
      <div class="flex--column">
        <h3>{{ 'fecal-scoring.detail.penscore.fecalsevere' | translate }}</h3>
      </div>
    </div>
  </div>

  <div class="spacing--margin-top spacing--margin-bottom flex--row flex--wrap penscorediv">
    <div class="flex--column penscoreimgdiv">
      <img src="assets/images/FecalScoring/FecalSevere.jpg" class="penscoreimg" />
    </div>
    <div class="flex--column spacing--margin-left penvaluediv">
      <span class="text--small text--bold label"
        >{{ 'fecal-scoring.detail.penscore.value' | translate }}:
        {{ penScoreFormGroup.controls.penScoreSevere.value }}%
      </span>

      <div class="flex--column spacing--margin-right penslider">
        <mat-slider
          discrete
          showTickMarks
          min="0"
          max="100"
          step="5"
          data-test="create-fecal-scoring__fecal-scoring-penscoresevere"
        >
          <input matSliderThumb formControlName="penScoreSevere" />
        </mat-slider>
      </div>

      <div class="spacing--margin-top">
        <div class="spacing--margin-bottom">
          <div>
            {{ 'fecal-scoring.detail.penscore.fecaltotal' | translate }}
            <span
              class="text--bold"
              [ngClass]="totalScore !== 100 ? 'text-color--warn-500' : 'text-color--primary-500'"
              >{{ totalScore }}%</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>

  <hr />

  <div class="spacing--margin-top">
    <div class="spacing--margin-bottom">
      <div>
        {{ 'fecal-scoring.detail.penscore.fecaltotal' | translate }}
      </div>
      <div>
        <span
          class="text--bold"
          [ngClass]="totalScore !== 100 ? 'text-color--warn-500' : 'text-color--primary-500'"
          >{{ totalScore }}%</span
        >
      </div>
      <mat-error *ngIf="this.penScoreFormGroup.controls.penScoreTotal.invalid">
        {{ 'fecal-scoring.detail.penscore.error-total' | translate }}</mat-error
      >
    </div>
  </div>
</form>
